@let code = controls().code;
@let number = controls().number;

<div class="relative">
  <input type="tel" class="w-24 pr-4"
         [formField]="code" placeholder="ISD Code"
         [matAutocomplete]="codeOptions">
  <fa-icon [icon]="icons.dropdownIndicator"
           class="absolute top-1/2 -right-0.5 -translate-y-1/2
              pointer-events-none text-2xl text-on-surface-variant"></fa-icon>

  <mat-autocomplete #codeOptions panelWidth="auto"
                    hideSingleSelectionIndicator>
    @for(option of isdCode.filtered(); track option.id) {
    <mat-option [value]="option.code">
      <div class="flex gap-4 items-center">
        <span class="font-emoji">{{option.flag}}</span>
        <span>{{option.code}}</span>
      </div>
    </mat-option>
    }
  </mat-autocomplete>

  @for (error of code().errors(); track error.kind) {
  <span class="error">{{error | errorMessage}}</span>
  }
</div>

<input type="tel" [formField]="number" placeholder="Number">
